<template>
  <card shadow footerClasses="py-2 text-center" bodyClasses="p-1">
    <div slot="header" class="bg-white border-0">
      <div class="row align-items-center">
        <div class="col-8">
          <h3 class="mb-0">
            Seleção
            <span class="text-warning">STARS</span>
          </h3>
        </div>
      </div>
    </div>
    <template>
      <div class="row text-center">
        <div class="col-md-4 mt-2">
          <img src="/img/pages/call.png" width="150" alt="..." />
          <h3 class="mt-3">
            <span class="bg-white rounded border p-2">{{ process.title }}</span>
          </h3>
        </div>
        <div class="col-md-8">
          <div
            class="card-profile-stats d-flex justify-content-center pt-1"
            v-if="process.external_link"
          >
            <div>
              <span
                class="text-capitalize btn btn-link p-0 m-0 cursor-pointer text-primary heading"
                title="Abrir página"
                @click="openLink(process.external_link)"
                >Visualizar</span
              >
              <span class="description">Mais informações</span>
            </div>
          </div>
          <div class="row text-center mb-3" v-if="process.keywords">
            <div class="col-12">
              <h3>
                Palavras-chave:
                <span class="font-weight-light">
                  <base-button
                    size="sm"
                    class="cursor-inherit"
                    v-for="(keyword, index) in process.keywords"
                    :key="'sector_' + index"
                    :type="bgClasses[index % bgClasses.length]"
                  >
                    {{ keyword }}
                  </base-button>
                </span>
              </h3>
            </div>
          </div>
          <div class="row text-center">
            <div class="col-12">
              <h3 v-if="process.region">
                Região:
                <span class="font-weight-light">
                  {{ process.region }}
                </span>
              </h3>
              <h3>
                <span v-if="process.end_date">
                  Período das aplicações:
                  <span class="font-weight-light">
                    {{
                      process.start_date
                        ? formatDate(process.start_date, "ll")
                        : "..."
                    }}
                    até
                    {{ formatDate(process.end_date, "ll") }}
                  </span>
                </span>
                <span v-else>
                  Início das aplicações:
                  <span class="font-weight-light">
                    {{
                      process.start_date
                        ? formatDate(process.start_date, "ll")
                        : "..."
                    }}
                    <span v-if="process.start_date"> (fluxo contínuo)</span>
                  </span>
                </span>
              </h3>
            </div>
          </div>
          <div v-if="count">
            <h4>
              Inscrições:
              <badge type="info" class="p-2">{{ count.subscriptions }}</badge>
            </h4>
          </div>
        </div>
      </div>
    </template>
    <div slot="footer">
      <base-button
        type="white"
        @click="$router.push(`/admin/selecoes/${process.id}/editar`)"
        ><i class="fas fa-edit text-info mr-2"></i>Editar seleção</base-button
      >
    </div>
  </card>
</template>
<script>
export default {
  name: "selecao-card",
  props: {
    process: {
      type: Object,
      required: true,
    },
    count: {
      type: Object,
      description: "Subscription count",
    },
  },
  data() {
    return {
      bgClasses: [
        "warning",
        "info",
        "primary",
        "success",
        "secondary",
        "danger",
        "light",
        "dark",
      ],
    };
  },
  methods: {
    openLink(link) {
      window.open(link, "file-window", "resizable=1,height=750,width=750");
    },
  },
};
</script>
<style scoped>
.card-profile-stats > div .heading {
  font-size: 1rem;
}
</style>
